const map = {
	"./az/az.json": [
		213,
		[
			213
		]
	],
	"./az/common.json": [
		835,
		[
			835
		]
	],
	"./en/common.json": [
		515,
		[
			515
		]
	],
	"./en/en.json": [
		885,
		[
			885
		]
	],
	"./es/common.json": [
		290,
		[
			290
		]
	],
	"./es/es.json": [
		103,
		[
			103
		]
	],
	"./pl/common.json": [
		38,
		[
			38
		]
	],
	"./pl/pl.json": [
		967,
		[
			967
		]
	],
	"./ru/common.json": [
		389,
		[
			389
		]
	],
	"./ru/ru.json": [
		989,
		[
			989
		]
	],
	"./tg/common.json": [
		965,
		[
			965
		]
	],
	"./tg/tg.json": [
		717,
		[
			717
		]
	],
	"./uk/common.json": [
		514,
		[
			514
		]
	],
	"./uk/uk.json": [
		335,
		[
			335
		]
	],
	"./uz/common.json": [
		31,
		[
			31
		]
	],
	"./uz/uz.json": [
		245,
		[
			245
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 800;
module.exports = webpackAsyncContext;